import { Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Messages from "@/components/Messages";

export default function MessagesPage() {
    const { user, loading } = useAuth();
    const [params] = useSearchParams();
    const compose = params.get("compose")?.replace(/^@/, "") || "";
    const convId = params.get("conv") || "";

    if (loading) return <div className="min-h-screen grid place-items-center text-white/60">Loading…</div>;
    if (!user) return <Navigate to="/auth" />;
    return <Messages standalone initialComposeHandle={compose} initialConvId={convId} />;
}